import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", " \n  ", " \n  ", " \n  border: none;\n  color: ", ";\n  box-sizing: border-box;\n  font-size: 12px;\n  font-weight: 600;\n  position: relative;\n  text-align: left;\n  vertical-align: top;\n  &:focus {\n    outline: solid 2px ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: 2px solid ", ";\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { B100 } from '@atlaskit/theme/colors';
import { head } from '../theme';
import { arrowsStyle, cellStyle, onClickStyle, truncateStyle } from './constants';
var rankingStyles = css(_templateObject());
export var Head = styled.thead(_templateObject2(), head.borderColor, function (_ref) {
  var isRanking = _ref.isRanking;
  return isRanking && rankingStyles;
});
export var HeadCell = styled.th(_templateObject3(), function (_ref2) {
  var onClick = _ref2.onClick;
  return onClickStyle({
    onClick: Boolean(onClick)
  });
}, function (p) {
  return truncateStyle(p);
}, function (p) {
  return arrowsStyle(p);
}, cellStyle, head.textColor, B100);